<li class="nav-item dropdown position-relative" ngbDropdown>
  <a
    class="nav-link dropdown-toggle"
    ngbDropdownToggle
    href="#"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    [attr.aria-label]="'Notifications' + (hasUnreadNotifications() ? ' (' + unreadCount() + ' unread)' : '')">
    <i class="bi bi-bell"></i>
    @if (hasUnreadNotifications()) {
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
        {{ unreadCount() }}
        <span class="visually-hidden">unread notifications</span>
      </span>
    }
  </a>

  <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
    <li>
      <h6 class="dropdown-header d-flex justify-content-between align-items-center">
        <span>Notifications</span>
        @if (hasNotifications()) {
          <div class="d-flex gap-1">
            @if (hasUnreadNotifications()) {
              <button
                type="button"
                class="btn btn-link btn-sm p-0 text-decoration-none"
                (click)="markAllAsRead(); $event.stopPropagation()"
                title="Mark all as read">
                <small>Mark all read</small>
              </button>
            }
            <button
              type="button"
              class="btn btn-link btn-sm p-0 text-decoration-none"
              (click)="clearAllRead(); $event.stopPropagation()"
              title="Clear read notifications">
              <small>Clear read</small>
            </button>
          </div>
        }
      </h6>
    </li>

    @if (!hasNotifications()) {
      <li>
        <div class="dropdown-item-text text-center text-muted py-3">
          <i class="bi bi-bell-slash fs-4 d-block mb-2"></i>
          <small>No notifications</small>
        </div>
      </li>
    } @else {
      @for (notification of notifications(); track notification.id) {
        <li>
          <div
            [class]="getNotificationClass(notification)"
            [class.notification-clickable]="isNotificationClickable(notification)"
            [class.notification-non-clickable]="!isNotificationClickable(notification)"
            (click)="onNotificationClick(notification)"
            [attr.role]="isNotificationClickable(notification) ? 'button' : null"
            [attr.tabindex]="isNotificationClickable(notification) ? '0' : null"
            [attr.aria-label]="notification.title + (notification.isRead ? '' : ' (unread)')">
            <div class="d-flex align-items-start gap-2">
              <!-- Notification Icon -->
              <div class="flex-shrink-0">
                <i
                  [class]="getNotificationIcon(notification) + ' fs-5'"
                  [class.text-primary]="!notification.isRead"
                  [class.text-muted]="notification.isRead"></i>
              </div>

              <!-- Notification Content -->
              <div class="flex-grow-1 min-width-0">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="flex-grow-1 min-width-0">
                    <div class="fw-semibold text-wrap" [class.text-primary]="!notification.isRead">
                      {{ notification.title }}
                    </div>
                    @if (notification.message) {
                      <small class="text-muted d-block text-wrap">
                        {{ notification.message }}
                      </small>
                    }

                    <!-- Progress Indicator for Processing Downloads -->
                    @if (showProgressIndicator(notification)) {
                      <div class="progress mt-2" style="height: 4px">
                        <div
                          class="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          style="width: 100%"
                          aria-label="Processing"></div>
                      </div>
                    }

                    <small class="text-muted">
                      {{ getRelativeTime(notification.createdDate) }}
                    </small>
                  </div>

                  <!-- Remove Button -->
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-1 text-muted flex-shrink-0"
                    (click)="removeNotification(notification, $event)"
                    title="Remove notification"
                    aria-label="Remove notification">
                    <i class="bi bi-x"></i>
                  </button>
                </div>

                <!-- Unread Indicator -->
                @if (!notification.isRead) {
                  <div class="position-absolute top-50 start-0 translate-middle-y">
                    <span class="badge bg-primary rounded-circle p-1" style="width: 8px; height: 8px"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        </li>
      }

      <!-- Show More Link (if needed) -->
      @if (notifications().length >= 10) {
        <li><hr class="dropdown-divider" /></li>
        <li>
          <a class="dropdown-item text-center" href="/notifications">
            <small>View all notifications</small>
          </a>
        </li>
      }
    }
  </ul>
</li>
